module.exports = __webpack_public_path__ + "images/Play.0e16946c8d4647c22c8f7ebacf76e4b0.svg";